import React, { useEffect, useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { helpHttp } from "../../helpers/helpHttp";
import { BASE_API } from "../../api/Globals";
import { Sidebar } from "primereact/sidebar";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from 'primereact/toast';
import { Tooltip } from 'primereact/tooltip';
import { Galleria } from 'primereact/galleria';
import { DataView } from "primereact/dataview";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import excelLogo from "../../assets/img/excelLogo.png"
import { storage } from "../../helpers/storage";

const DialogDocumentoCT = (
    {
        visible = false,
        header = "",
        onHide = () => { },
        draggable,
        topContent = [],
        dataBin = [],
        idUsuario,
        idUsuarioPerfil,
        stylePersonalizado = "",
        ciclo = {},
        obtenerReporte
    }
) => {

    const [buscador, setBuscador] = useState("");
    const [documentos, setDocumentos] = useState([]);
    const [detalleFolio, setDetalleFolio] = useState([]);
    const [CCT, setCCT] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialogDocumentos, setOpenDialogDocumentos] = useState(false);
    const [loadingCT, setLoadingCT] = useState(false);
    const [file, setFile] = useState('')
    const [files, setFiles] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [bandera, setBandera] = useState(false);
    const [openDialogDescargar, setOpenDialogDescargar] = useState(false)
    const toast = useRef(null);

    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    useEffect(() => {
        setDetalleFolio(topContent)
    }, [topContent])

    useEffect(() => {
        if (visible === false) {
            setBuscador("");
            setCCT([]);
            setLoadingCT(false);
        }
    }, [visible])

    const base64toBlob = (data) => {
        // console.log(data)
        try {
            if (data !== null) {
                const matches = data.match(/^data:(.+);base64,(.*)$/);

                const mimeType = matches[1]; // Extract the MIME type
                const base64 = matches[2]; // Extract the Base64 data

                const bytes = atob(encodeURI(base64))
                let lenght = new Array(bytes.length)
                for (let i = 0; i < lenght; i++) {
                    lenght[i] = bytes.charCodeAt(i)
                }
                const byteArray = new Uint8Array(lenght)
                return new Blob([byteArray], { type: mimeType })
            } else {
                return null;
            }
        } catch (err) {
            console.warn("Error: ", err)
            return null;
        }


    }

    const AbrirArchivo = (contenido) => {
        if ([".png", ".jpg", ".jpeg"].includes(contenido.TipoArchivo)) {
            console.log('entra')
            let imgData = contenido.Archivo
            setFile(
                "<img width='auto' height='100%' src=" + imgData + " />"
            )
            setOpenDialog(true);
        } else {
            const linkSource = contenido.Archivo
            const bytes = base64toBlob(linkSource)
            console.log(bytes)
            if (bytes !== null) {
                if (contenido.TipoArchivo === ".pdf" && bytes.size < 1500000) {
                    setFile(
                        "<iframe width='100%' height='100%' src='" + linkSource + "'></iframe>"
                    )
                    setOpenDialog(true);
                } else {
                    toast.current.show({ severity: 'success', summary: 'Aviso', detail: 'El archivo es demasiado grande para abrirlo, se ha descargado.', life: 9000 });
                    const downloadLink = document.createElement('a')
                    const fileName = contenido.NombreArchivo
                    downloadLink.href = linkSource
                    downloadLink.download = fileName
                    downloadLink.click();
                }
            } else {
                toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Archivo en proceso de guardado, intente más tarde.', life: 9000 });
            }
        }
        setOpenDialogDescargar(false)
    }

    const obtenerArchivo = async (documentos, contenido) => {
        setOpenDialogDescargar(true)

        if ([".png", ".jpg", ".jpeg"].includes(contenido.TipoArchivo)) {
            setBandera(true);
            setActiveIndex(documentos.filter(x => [".png", ".jpg", ".jpeg"].includes(x.TipoArchivo)).indexOf(contenido))
            const imageItems = await Promise.all(
                documentos.filter(item => [".png", ".jpg", ".jpeg"].includes(item.TipoArchivo)).map(async (x) => {
                    return await helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
                        body: {
                            "Opcion": "O",
                            "CicloEscolar": "",
                            "TipoMaquila": "",
                            "TipoArchivo": "",
                            "RutaArchivo": "",
                            "id": x.id,
                            "IdUsuario": idUsuario,
                            "NombreArchivo": "",
                            "Folio": detalleFolio.idFolioMaquila,
                            "FechaCreate": new Date().toISOString(),
                            "Activo": true,
                            "Archivo": "",
                            "IdCicloEscolar": x.IdCicloEscolar,
                            "parametrosExtra": `[{"idFolio": ${x.Folio}, "idTarea": ${x.TipoMaquila}}]` //se usan estos campos como provicionales
                        },
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "Accept": "application/json",
                            'Authorization': `Bearer ${storage.get('token')}`
                        }
                    }).then(async (res) => {
                        if (res.SUCCESS) {
                            const base64 = [".jpg"].includes(res.ITEMS.TipoArchivo) ? await convertJpgBase64ToJpeg(res.ITEMS.Archivo) : res.ITEMS.Archivo
                            try {
                                let item = {
                                    itemImageSrc: base64,
                                    title: res.ITEMS.NombreArchivo.toLowerCase().endsWith('.jpg') ? res.ITEMS.NombreArchivo.slice(0, -4) + '.jpeg' : res.ITEMS.NombreArchivo
                                }
                                return item;
                            } catch (err) {
                                return null;
                            }
                        } else {
                            return null;
                        }
                    })
                })
            );

            if (imageItems.length !== 0) {
                setFiles(imageItems);
                setOpenDialog(true);
                setOpenDialogDescargar(false)
            }
        } else {
            setBandera(false);
            helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
                body: {
                    "Opcion": "O",
                    "CicloEscolar": "",
                    "TipoMaquila": "",
                    "TipoArchivo": "",
                    "RutaArchivo": "",
                    "id": contenido.id,
                    "IdUsuario": idUsuario,
                    "NombreArchivo": "",
                    "Folio": detalleFolio.idFolioMaquila,
                    "FechaCreate": new Date().toISOString(),
                    "Activo": true,
                    "Archivo": "",
                    "IdCicloEscolar": contenido.IdCicloEscolar,
                    "parametrosExtra": `[{"idFolio": ${contenido.Folio}, "idTarea": ${contenido.TipoMaquila}}]` //se usan estos campos como provicionales
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if (res.SUCCESS) {
                    AbrirArchivo(res.ITEMS)
                }
            })
        }
    }

    const Adjuntos = (data) => {
        helpHttp().post(`${BASE_API}Usuarios/EvidenciaMaquila`, {
            body: {
                "Opcion": "S",
                "CicloEscolar": "",
                "TipoMaquila": "",
                "TipoArchivo": "",
                "RutaArchivo": "",
                "id": null,
                "IdUsuario": idUsuario,
                "NombreArchivo": "",
                "Folio": data.idFolioMaquila,
                "FechaCreate": new Date().toISOString(),
                "Activo": true,
                "Archivo": "",
                "IdCicloEscolar": ciclo.IdCicloEscolar,
                "parametrosExtra": `[{"idFolio": ${data.idFolioMaquila}, "idTarea": ${data.idTareaFolioMaquila}}]`
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }

        }).then(res => {
            if (res.SUCCESS) {
                if (res.ITEMS.length > 1) {
                    if (res.ITEMS.every(objeto => [".png", ".jpg", ".jpeg"].includes(objeto.TipoArchivo))) {
                        obtenerArchivo(res.ITEMS, res.ITEMS[0])
                    } else {
                        setDocumentos(res.ITEMS);
                        setOpenDialogDocumentos(true);
                    }
                } else {
                    obtenerArchivo(res.ITEMS, res.ITEMS[0])
                }
            }
        })
    }

    const convertJpgBase64ToJpeg = async (base64Jpg, quality = 0.92) => {
        return new Promise((resolve, reject) => {
            try {
                const img = new Image();

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);

                    // Convertir a JPEG y resolver la promesa
                    const jpegBase64 = canvas.toDataURL('image/jpeg', quality);
                    resolve(jpegBase64);
                };

                img.onerror = () => {
                    reject(new Error('Error al cargar la imagen'));
                };

                img.src = base64Jpg;
            } catch (error) {
                reject(error);
            }
        });
    }

    const obtenerCtAdjuntos = () => {
        setLoadingCT(true);
        try {
            // if (buscador.trim().length > 0) {
                helpHttp().post(`${BASE_API}/Dinamico/ConsultaDinamica`, {
                    body: {
                        'sp': "spdGetCtsFolioMaquila",
                        'tipo': 0,
                        'parametros': [
                            { "IdCicloEscolar": ciclo.IdCicloEscolar },
                            { "Id_Folio": detalleFolio.idFolioMaquila },
                            { "CCT": buscador }
                        ]
                    },
                    headers: {
                        'Content-Type': 'application/json; charset=utf-8',
                        'Accept': 'application/json',
                        'Authorization': `Bearer ${storage.get('token')}`
                    }
                }).then(res => {
                    if (res.SUCCESS) {
                        setCCT(res.ITEMS);
                        setLoadingCT(false);
                    }
                });
            // } else {
                // toast.current.show({ severity: "warn", summary: "Aviso", detail: "Favor de ingresar clave de CT para la búsqueda.", life: 5000 })
                // setLoadingCT(false);
            // }
        } catch (error) {
            console.warn("Error al consultar:", error);
            setLoadingCT(false);
        }
    }

    const listTemplate = (item) => {
        let indice = item.NombreArchivo.indexOf(".")
        let resultado = item.NombreArchivo.substring(0, indice)
        return (
            <div className="col-12 lg:col-3 md:col-4 p-2 text-center">

                <div style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px', borderRadius: '15px' }}>
                    <br />
                    <Tooltip target=".nombreArchivolabel" mouseTrack mouseTrackLeft={10} />
                    <i className='pi pi-image' style={{ fontSize: '40px', marginTop: '15px' }} />
                    <br />
                    <div className='nombreArchivolabel' data-pr-tooltip={item.NombreArchivo} style={{ color: 'black', fontSize: '16px', marginTop: '5px' }}>{item.NombreArchivo.substring(0, 16).toLowerCase()}..{item.TipoArchivo}</div>
                    {/* <div style={{ color: 'black', marginTop: '5px' }}>Tipo {item.TipoArchivo }</div> */}
                    {/* <div style={{ color: 'black', marginTop: '5px' }}>Ciclo {item.Descripcion}</div>
                    <div style={{ color: 'black', marginTop: '5px' }}>{new Date(item.FechaCreate.split('T').shift()).toLocaleDateString('en-GB')}</div> */}
                    <div style={{ color: 'black', fontSize: '11px', marginTop: '5px' }} />
                    <br />
                    <div className="col-12">
                        <Button className="p-button p-component" style={{ marginBottom: '10px', width: '64%', justifyContent: 'center' }} onClick={() => obtenerArchivo(documentos, item)}>Ver</Button>
                        {/* <Button className="p-button-outlined p-component" style={{ marginBottom: '10px', width: '64%', justifyContent: 'center' }} onClick={() => AbrirConfirmacion(item)}>Eliminar</Button> */}
                    </div>
                </div>
            </div>
        )
    }

    const ctsTemplate = (item) => {
        return (
            <div className='grid mx-3' style={{ width: "100%" }}>

                <div className='col-10'>
                    <div>{item.codigo}</div>
                </div>

                {/* <Tooltip target=".custom-target-label" /> */}

                <div className='col-1' style={{ textAlign: 'right', alignSelf: 'right' }}>
                    <Tooltip target=".p-tooltip-target" />
                    <i className='adjuntoMaquilaIcon pi pi-paperclip mr-1 p-tooltip-target' data-pr-tooltip="Ver adjuntos" style={{ cursor: 'pointer', fontSize: '23px' }} onClick={() => Adjuntos(item)} ></i>
                </div>


            </div>
        )
    }

    const bodyTemplateTipoMaq = () => {
        return (
            <div>{detalleFolio.TipoMaquila} ({detalleFolio.valorTipoMaquila})</div>
        )
    }

    const itemTemplate = (item) => {
        return <img src={item.itemImageSrc} alt={item.alt} style={{ width: 'auto', maxHeight: '410px', display: 'block', maxWidth: '-webkit-fill-available' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.itemImageSrc} alt={item.alt} style={{ display: 'block', width: '100px', height: '100px' }} />;
    }

    const caption = (item) => {
        return (
            <React.Fragment>
                <div className="text-white">{item.title}</div>
            </React.Fragment>
        );
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={visible} blockScroll={true} header={header} onHide={() => onHide()} draggable={Boolean(draggable)} breakpoints={{ "800px": "100%" }} style={stylePersonalizado === "" ? { width: '80%', height: '90%' } : stylePersonalizado}
                footer={
                    <div className='p-component-modal-tabla' style={{ float: 'right' }}>
                    </div>
                }
            >
                <div className="grid m-3">
                    <DataTable value={detalleFolio !== null ? [detalleFolio] : []} responsiveLayout={false} size="small" style={{ border: "solid 1px lightgray", marginTop: "10px", marginBottom: "10px", fontWeight: "bold", width: "100%" }}>
                        <Column field='Folio' header="Folio" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>
                        <Column field='Municipio' header="Municipio" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>
                        {idUsuarioPerfil !== 16 && <Column header="Tipo maquila" body={bodyTemplateTipoMaq} headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>}
                        <Column header="Estatus" field='Estatus' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>
                        {idUsuarioPerfil !== 16 && <Column header="Total CTs" field='totalcts' headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }}></Column>}
                        {idUsuarioPerfil !== 16 && <Column header="Descargar CTs" headerStyle={{ backgroundColor: '#9b2f3e', color: 'white', justifyItems: 'center' }} style={{ textAlign: "center" }} body={rowData =>
                            <div className="App">
                                <Button rounded text style={{ padding: '4px' }} onClick={() => obtenerReporte(rowData)} >
                                    <img src={excelLogo} style={{ height: "18px", cursor: "pointer" }} />
                                </Button>
                            </div>
                        }></Column>}
                    </DataTable>

                    <div className="flex surface-200 border-round w-full mb-4 p-2">
                        <span className="p-input-icon-left w-full">
                            <i className="pi pi-search" />
                            <InputText value={buscador} placeholder="Buscar ct" className="w-full" onChange={e => setBuscador(e.target.value)} />
                        </span>
                        <Button className="p-button w-1 ml-2" icon="pi pi-search" tooltip="Buscar" loading={loadingCT} onClick={obtenerCtAdjuntos} />
                    </div>
                    <DataView
                        className="w-full"
                        value={CCT}
                        loading={loadingCT}
                        emptyMessage="No se encontraron resultados"
                        itemTemplate={ctsTemplate}
                    />
                </div>
            </Dialog>

            <Dialog visible={openDialogDocumentos} blockScroll={true} header={header} onHide={() => { setOpenDialogDocumentos(false) }} draggable={Boolean(draggable)} breakpoints={{ "800px": "100%" }} style={stylePersonalizado === "" ? { width: '80%', height: '90%' } : stylePersonalizado}
                footer={<div className='p-component-modal-tabla' style={{ float: 'right' }}></div>}>
                <div style={{ height: '100%', overflow: 'hidden', textAlign: 'center' }} >
                    <div className="grid">
                        <div className="col-12 border-2 border-round border-gray-200">
                            <DataView
                                className="w-full"
                                value={documentos}
                                emptyMessage="No se encontraron resultados"
                                itemTemplate={listTemplate}
                            />
                        </div>
                    </div>

                    <Dialog
                        header='CARGANDO DOCUMENTOS'
                        blockScroll={true}
                        visible={openDialogDescargar}
                        closable={false}
                        breakpoints={{ "800px": "100%" }}
                        style={{ width: "80%", height: "90%" }}
                        showHeader={false}
                        contentStyle={{ background: 'lightgray', opacity: '60%' }}
                        draggable={false}
                    >
                        <div className="text-center" style={{ marginTop: '200px' }}>
                            <ProgressSpinner />
                            <div className="col-12" style={{ color: 'black', fontSize: '14px' }}><strong>Cargando documento...</strong></div>
                        </div>
                    </Dialog>

                </div>
            </Dialog>

            <Dialog id='dialog_carrusel' visible={openDialog} blockScroll={true} header={header} onHide={() => { setOpenDialog(false); setFile(null) }} draggable={Boolean(draggable)} breakpoints={{ "800px": "100%" }} style={stylePersonalizado === "" ? { width: '80%', height: '90%' } : stylePersonalizado}
                footer={<div className='p-component-modal-tabla' style={{ float: 'right' }}></div>}>
                {
                    bandera !== true ?
                        <div style={{ width: '100%', height: '100%', overflow: 'hidden' }} dangerouslySetInnerHTML={{ __html: file }} />
                        :
                        <Galleria value={files} responsiveOptions={responsiveOptions} numVisible={4} item={itemTemplate} thumbnail={thumbnailTemplate} caption={caption} />
                }
            </Dialog>
        </>
    )
}

export default DialogDocumentoCT